<script setup>
	import { DsIcon } from '@coloplast/design-system';
	import { isExternalUrl } from 'shared/services/urlTypeService';
	import { computed } from 'vue';

	const props = defineProps({
		item: {
			type: Object,
			required: true,
		},
	});

	const checkIfExternalUrl = computed(() => isExternalUrl(props.item.LinkUrl) ? '_blank' : '_self');
</script>

<template>
	<article class="c-quick-links__list-item">
		<a
		   v-if="item.LinkUrl"
		   class="c-quick-links__list-link"
		   :href="item.LinkUrl"
		   :target="checkIfExternalUrl"
		  >
		</a>
		<DsIcon
			v-if="item.Icon"
			:icon-name="item.Icon"
			:label="item.Icon"
			size="lg"
			class="c-quick-links__list-watermark"
		/>
		<div>
			<h2 v-if="item.Headline"
				class="c-quick-links__list-headline"
				v-html="item.Headline"
				>
			</h2>
			<p v-if="item.Description"
			   class="c-quick-links__list-description"
			   v-html="item.Description"
			   >
			</p>
		</div>
	</article>
</template>
